export const projects = [
    /* {
        id: 0,
        title: 'Weather WebApp',
        description: 'Mí primera aplicacion web, realizada con VueJs. Usted debe seleccionar un país, luego elegir una ciudad y en cuestión de segundos te indicará la situación meteorológica del momento.',
        image_project: 'WeatherApp.webp',
        link_repository: null,
        link_demo: 'https://weather-site-rf.netlify.app/',
    }, */
    {
        id: 1,
        title: 'Portfolio Personal',
        description: 'Portfolio personal de la cual, usted se encuentra en estos momentos. Se usó el framework VueJs.',
        image_project: 'Portfolio.webp',
        link_repository: null,
        link_demo: 'https://rodrif-portfolio.netlify.app/',
    },
    {
        id: 2,
        title: 'Rick and Morty ',
        description: 'Primera aplicación web realizada en ReactJS, donde pongo en práctica el uso del Hook, useState, además del useEffect.',
        image_project: 'RickAndMorty.webp',
        link_repository: null,
        link_demo: 'https://rick-and-morty-app-r.netlify.app/',
    },
]